import React, { useRef } from 'react'
import { Col, Container, FormCheck, Row } from 'react-bootstrap'
import '../css/GoodSwitch.css'

const styles = {
    container: {
        paddingLeft: '0',
        paddingRight: '0',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center'
    },
    label: {
        display: 'flex',
        flexDirection: 'column',
        width: '70%'
    },
    switch: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '20%'
    },
    help: {
        width: '10%',
        display: 'flex',
        alignItems: 'center'
    }
}

const GoodSwitch = ({ value, onChange = (e) => console.log(e), label = undefined, reset = false, inverted = false, invertValue = false }) => {

    //const on = useRef(defaultChecked)
    const handleClick = () => {
        // on.current = !on.current
        //console.log(value)
        onChange(!value)
    }


    return (
        <div style={{ ...styles.container, flexDirection: inverted ? 'row-reverse' : 'row', justifyContent: inverted ? 'flex-end' : 'flex-start' }}>
            <div style={styles.switch}>
                {invertValue ?
                    (<span
                        className={`good-switch ${!value ? 'good-switch-on' : 'good-switch-off'}`}
                        onClick={handleClick}
                    >
                        <span className='good-switch-sphere' />
                    </span>)
                    :
                    (<span
                        className={`good-switch ${value ? 'good-switch-on' : 'good-switch-off'}`}
                        onClick={handleClick}
                    >
                        <span className='good-switch-sphere' />
                    </span>)
                }


            </div>
            <div style={styles.label}>
                {label && (
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{label}</p>
                )}
            </div>
        </div>
    )
}

export default GoodSwitch